export default {
  CustomTextData: null,
  CustomImageData: null,
  TemporalImage: null,
};
